export function isInternalUrl(url: string): boolean {
  return new URL(document.baseURI).origin == new URL(url, document.baseURI).origin
}
